import { render, staticRenderFns } from "./authorBlock.vue?vue&type=template&id=3a2fbffe&scoped=true&"
import script from "./authorBlock.vue?vue&type=script&lang=js&"
export * from "./authorBlock.vue?vue&type=script&lang=js&"
import style0 from "./authorBlock.vue?vue&type=style&index=0&id=3a2fbffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2fbffe",
  null
  
)

export default component.exports